import React, { Component } from 'react';
import {
  withRouter
} from 'react-router-dom';
import {
  Page,
  Card,
  Text,
  BlockStack,
  Badge,
  Banner,
  Button,
  Spinner,
  List,
  Collapsible,
  Checkbox,
  DropZone,
  RangeSlider,
  Select,
  Thumbnail,
  Modal,
  ChoiceList,

} from '@shopify/polaris';
// import {} from '@shopify/polaris-icons';
import utils from '../../../../../utils/utils';
import {
  reqGetImgOptTotal,
  reqSaveSettings,

} from "../../../../../api"
import { TEMPLATE_URL } from '../../../../../utils/constants';
import Switch from "react-switch";
import { store } from '../../../../../redux/store';
import '../index.scss';
import Language from '../../../../../i18n/Language';
import FreeTagInputMix from "../../../../../components/FreeTagInput";
import FreeTagInputTraceless from "../../../../../components/FreeTagInput/indexV2";
import { connect } from 'react-redux';
import { setImageAutoSwitchData } from '../../../../../redux/actions/getAppPublicData';
import cloneDeep from 'lodash-es/cloneDeep';
import debounce from 'lodash-es/debounce';
import { showNewMessage } from '@intercom/messenger-js-sdk';
import FooterTrustHelp from '../../../../../components/FooterTrustHelp';
import SaveBarTop from '../../../../../components/SaveBarTop';
const t = Language;

class ImageSettings extends Component {

  state = {
    //页面动作
    loading: true,
    loadingPage: true,
    LanguageRefreshData: false,
    existUser: false, // 是否存在首次设置
    // 表格条数
    current_PageSize: 5,
    current_PageSize_alt: 5,
    isShowQuotaImage: true, // 额度banner状态

    level: 1, // 等级
    switchLoading: false, // 开关loading
    auto_switch: false,
    isShowAutoState: false, // 是否展示自动状态
    FirstSetActive: false, // 首次设置弹窗状态
    isShowManuallyModal: false, // 手动弹窗状态
    firstSetSheetActive: false, // 抽屉状态

    is_default: 1, // 是否第一次设置
    total_saved_size: 0, // 比特单位
    avg_saved_space: 0,
    avg_saved_percent: 0,
    total_original_size: 0,
    total_compress_size: 0,
    optimize_status: 0,

    impressionsUse: 0, // 使用额度
    impressionsAll: 0, // 总额度
    impressionsProportion: 0,  // 占比额度
    freeQuota: 150,  // 免费额度

    image_opt: {}, // 基础设置
    alt_text: {}, // alt设置
    file_name: {}, // 文件名称设置

    isShowImgCompression: false, // 开关状态
    isShowImgAltText: false, // 开关状态
    isShowImgFilename: false, // 开关状态
    productImg: 0, // check状态
    ColImg: false, // check状态
    BlogImg: false, // check状态
    ConvertImg: false, // check状态
    AddWaterImg: false, // check状态
    productAlt: 0, // check状态
    ColAlt: false, // check状态
    BlogAlt: false, // check状态
    blankImgAlt: false, // check状态
    productFile: 0, // check状态
    ColFile: false, // check状态
    BlogFile: false, // check状态
    setSaveLoading: false, // 保存设置loading
    setSaveDisabled: true, // 是否禁用save
    tagSet: {},
    proAltTag: '',    // tag输入框
    colAltTag: '',
    blogAltTag: '',
    proFileTag: '',
    colFileTag: '',
    blogFileTag: '',
    productAltList: [
      {
        content: '{{Product title}}',
        onAction: () => this.addApplyField('Product title', 'ProductAltFixTag')
      },
      {
        content: '{{Product vendor}}',
        onAction: () => this.addApplyField('Product vendor', 'ProductAltFixTag')
      },
      {
        content: '{{Product type}}',
        onAction: () => this.addApplyField('Product type', 'ProductAltFixTag')
      },
      {
        content: '{{Price}}',
        onAction: () => this.addApplyField('Price', 'ProductAltFixTag')
      },
      {
        content: '{{Shop name}}',
        onAction: () => this.addApplyField('Shop name', 'ProductAltFixTag')
      },
      {
        content: '{{Product variant}}',
        onAction: () => this.addApplyField('Product variant', 'ProductAltFixTag')
      },
    ],
    colAltTagList: [
      {
        content: '{{Collection title}}',
        onAction: () => this.addApplyField('Collection title', 'ColAltFixTag')
      },
      {
        content: '{{Shop name}}',
        onAction: () => this.addApplyField('Shop name', 'ColAltFixTag')
      }
    ],
    blogAltTagList: [
      {
        content: '{{Blog title}}',
        onAction: () => this.addApplyField('Blog title', 'BlogAltFixTag')
      },
      {
        content: '{{Shop name}}',
        onAction: () => this.addApplyField('Shop name', 'BlogAltFixTag')
      }
    ],
    productFileList: [
      {
        content: '{{Product title}}',
        onAction: () => this.addApplyField('Product title', 'ProductFileFixTag')
      },
      {
        content: '{{Product vendor}}',
        onAction: () => this.addApplyField('Product vendor', 'ProductFileFixTag')
      },
      {
        content: '{{Product type}}',
        onAction: () => this.addApplyField('Product type', 'ProductFileFixTag')
      },
      {
        content: '{{Price}}',
        onAction: () => this.addApplyField('Price', 'ProductFileFixTag')
      },
      {
        content: '{{Shop name}}',
        onAction: () => this.addApplyField('Shop name', 'ProductFileFixTag')
      },
      {
        content: '{{Product variant}}',
        onAction: () => this.addApplyField('Product variant', 'ProductFileFixTag')
      },
    ],
    colFileTagList: [
      {
        content: '{{Collection title}}',
        onAction: () => this.addApplyField('Collection title', 'ColFileFixTag')
      },
      {
        content: '{{Shop name}}',
        onAction: () => this.addApplyField('Shop name', 'ColFileFixTag')
      }
    ],
    blogFileTagList: [
      {
        content: '{{Blog title}}',
        onAction: () => this.addApplyField('Blog title', 'BlogFileFixTag')
      },
      {
        content: '{{Shop name}}',
        onAction: () => this.addApplyField('Shop name', 'BlogFileFixTag')
      }
    ],

    isShowSheetLoading: true,  // sheet loading
    allTagList: {}, // 初始化tag
    manuallyTabKey: 0, // 手动列表索引
    manuallyTableData: [], // 手动优化图片列表
    manuallyTableRes: {}, // 手动列表总数据
    manuallyQueryVal: '', // 手动搜索value
    mPage: 1, // 手动页码
    mPageSize: 10, // 条数

    showImageUploadBanner: false,
    setUpdateImageWarning: null,
    uploadedFiles: null,
    fileUpload: null,
    imgButton: true,    //图片删除按钮
    imageAddWatermarkPosition: '',
    imageAddWatermarkSize: 0,
    imageAddWatermarkOpacity: 1,

    ProductAltFixTag: {}, // tag输入对象
    ColAltFixTag: {}, // --
    BlogAltFixTag: {}, // --
    ProductFileFixTag: {}, // --
    ColFileFixTag: {}, // --
    BlogFileFixTag: {}, // tag输入对象
    imageAddWatermarkImg: '/imgs/ImageOpt/watermark.png', // 图片对象数据

    hPage: 1,   // 历史记录 页码
    hPageSize: 10,   // 历史记录 条数
    historyTableRes: {}, // 接口数据
    historyQueryVal: '',   // 历史记录 搜索
    historyTabKey: 0,   // 历史记录 索引
    historyTableData: [], // 表格数据
    historyTabLoading: true, // loading历史记录表

    isImageCompression: false,  // 当前开关状态
    isConvertImage: false,  // 当前开关状态
    isAddWatermark: false,  // 当前开关状态
    isImageAlttext: false,  // 当前开关状态
    isImageFilename: false,   // 当前开关状态

    tagActive: [], //  是否高亮tag输入框
    ProductAltFixTagPop: false,
    ColAltFixTagPop: false,
    BlogAltFixTagPop: false,
    ProductFileFixTagPop: false,
    ColFileFixTagPop: false,
    BlogFileFixTagPop: false,

    isShowManuallyBtnLoading: false,  // 手动按钮loading
    manuallyTableState: {},
    historyTableState: {},

    progressCp: 0,      // 当前完成优化数量
    progressAll: 0,     // 需要完成总量
    isShowProgress: -1,   // 是否展示进度条
    allOptType: true,       // 是否存在任意一个
    optType: '',          // 优化类型
    optPageType: 0,
    stopLoading: false,

    batchLoading: true,     // 批量操作loading
    historyyPre: false,     // 历史记录分页
    historyNext: false,
    manuallyPre: false,     // 手动分页
    manuallyNext: false,
    initStateBtn: true, // 手动按钮初始化状态
    addTagsProAlt: '',
    addTagsColAlt: '',
    addTagsBlogAlt: '',
    addTagsProFile: '',
    addTagsColFile: '',
    addTagsBlogFile: '',
    isInLoading: false,
    isLocalStorage: false,    // 是否无痕
    errorImage: '',
    isShowEditTip: [],
    isShowWatermarkTip: true,

    isShowCompressionLevel: !false,
    imageCompressionLevel: 2, // 推荐值
    imageCompressionLevelArr: {
      custom: 0,
      lossless: 0,
      custom_ratio: 0
    },
    isShowImgWatermark: false,

    isShowImgCompressionCol: true, // 伸缩状态
    isShowImgWatermarkCol: false,
    isShowImgAltTextCol: false,
    isShowImgFilenameCol: false,

    watermarkUrl: '/imgs/ImageOpt/watermark.png',  // 水印预览图片
    isShowSaveTip: false,
    ConvertImgJPG: false,
    isGuideTip: false,
    isShowFileExistModal: false,
    isNewUserState: true, // 是否新用户
    isShowFileOpt: true, // 是否展示文件名称优化
    allowList: [
      "Product title",
      "Product vendor",
      "Product type",
      "Product variant",
      "Price",
      "Shop name",
      "Collection title",
      "Blog title",
    ],
    isBlur: false,
  };

  UNSAFE_componentWillMount() {
    let isLocalStorage = null;
    try {
      sessionStorage.setItem('localState', 1)
      isLocalStorage = true;
    } catch {
      isLocalStorage = false;
    }
    this.setState({
      isLocalStorage,
    })
  }

  componentDidMount() {
    // 切换默认在顶部开始预览
    window.scrollTo(0, 0);
    this.getProductStatistics();
    const _params = this.props.location;
    this.setState({
      isGuideTip: Boolean(_params?.query === "showPopover"),
    })
  }

  // 获取产品页面统计数据
  getProductStatistics = async (isGetTable = true) => {
    const res = await reqGetImgOptTotal();
    if (res.ack === 1) {
      let t = res.total;
      let set = res.settings;
      let first = res.settings.is_default;
      this.setState({
        total_saved_size: this.changeBitInfo(t.total_saved_size),
        avg_saved_space: this.changeBitInfo(t.avg_saved_space),
        avg_saved_percent: Number(t.total_original_size) === 0 ? 0 : Number(((Number(t.total_saved_size) / Number(t.total_original_size)) * 100).toFixed(2)),
        total_original_size: Number(t.total_original_size),
        total_compress_size: Number(t.total_compress_size),
        optimize_status: 0,
        is_default: first, // 是否第一次设置
        // firstSetSheetActive: res.settings.is_default === 1 ? true : false, // 第一次设置默认弹出
        impressionsUse: res.opt_schedule.impressions_use,
        impressionsAll: res.opt_schedule.impressions_all,
        auto_switch: Boolean(res.settings.auto_switch), // 自动状态
        isShowAutoState: Boolean(res.settings.auto_switch), // 自动开关状态
        // 设置
        image_opt: set.image_opt,
        alt_text: set.alt_text,
        file_name: set.file_name,

        isShowImgCompression: Boolean(set.image_opt?.switch), // 开关状态
        isShowImgAltText: Boolean(set.alt_text?.switch), // 开关状态
        isShowImgFilename: Boolean(set.file_name?.switch), // 开关状态
        productImg: set.image_opt?.product,
        ColImg: Boolean(set.image_opt?.collection),
        BlogImg: Boolean(set.image_opt?.blogs),
        ConvertImg: Boolean(set.image_opt?.pngtojpg),
        AddWaterImg: Boolean(set.image_opt?.watermark?.switch),
        imageAddWatermarkPosition: set.image_opt?.watermark?.position,  // 水印参数
        imageAddWatermarkSize: Number(set.image_opt?.watermark?.image_height) * 100,
        imageAddWatermarkOpacity: set.image_opt?.watermark?.opacity,
        imageAddWatermarkImg: set.image_opt?.watermark?.logo,
        productAlt: set.alt_text?.product,
        ColAlt: Boolean(set.alt_text?.collection),
        BlogAlt: Boolean(set.alt_text?.blogs),
        blankImgAlt: Boolean(set.alt_text?.blank_replace),
        productFile: set.file_name?.product,
        ColFile: Boolean(set.file_name?.collection),
        BlogFile: Boolean(set.file_name?.blogs),
        proAltTag: this.setDefaultTagFormat('product', set.alt_text?.product_rule),
        colAltTag: this.setDefaultTagFormat('collection', set.alt_text?.collection_rule),
        blogAltTag: this.setDefaultTagFormat('blog', set.alt_text?.blogs_rule),
        proFileTag: this.setDefaultTagFormat('product', set.file_name?.product_rule),
        colFileTag: this.setDefaultTagFormat('collection', set.file_name?.collection_rule),
        blogFileTag: this.setDefaultTagFormat('blog', set.file_name?.blogs_rule),

        // watermarkUrl: '/imgs/ImageOpt/watermark.png',  // 水印预览图片
        ConvertImgJPG: Boolean(set.image_opt?.pngtojpg_size_control),
        imageCompressionLevel: Boolean(set.image_opt?.quality) ? set.image_opt?.quality.custom === 0 ? 2 : (set.image_opt?.quality.custom_ratio === 90 ? 1 : set.image_opt?.quality.custom_ratio === 75 ? 2 : 3) : 2, // 推荐值
        imageCompressionLevelArr: Boolean(set.image_opt?.quality) ? set.image_opt.quality : { custom: 0, lossless: 0, custom_ratio: 0 },
        // isShowManuallyBtnLoading: res.opt_schedule.opt_total > 0 && res.opt_schedule.process_result !== 1 ? true : false,

        setSaveDisabled: first === 1 ? false : true,

        level: store.getState().public?.level,
        loadingPage: false,
        isShowSheetLoading: false,
        isShowFileOpt: Boolean(res.settings?.show_opt_file_name),
      }, () => {
        this.props.setImageAutoSwitch({ type: 'imageOptAuto', value: Boolean(res.settings.auto_switch) })
        this.handleDropImage(0, '', set.image_opt?.watermark?.logo);
        // 存储源数据，用于舍弃时回退（避免重新请求接口）
        this.setState({ originSetData: this.getFormSnapshot() });
      })
    } else {
      this.props.toggleToast(res.message, true);
    }
  }

  // 设置tag
  setDefaultTag = () => {
    let { proAltTag, colAltTag, blogAltTag, proFileTag, colFileTag, blogFileTag, productAltList, colAltTagList, blogAltTagList, productFileList, colFileTagList, blogFileTagList } = this.state;
    let allTagList = {
      proAltTag: Boolean(proAltTag) ? proAltTag : `[[{"value":"{{${productAltList[0]['content']}}}"}]] - [[{"value":"{{${productAltList[4]['content']}}}"}]]`, // product
      colAltTag: Boolean(colAltTag) ? colAltTag : `[[{"value":"{{${colAltTagList[0]['content']}}}"}]] - [[{"value":"{{${colAltTagList[1]['content']}}}"}]]`, // collection
      blogAltTag: Boolean(blogAltTag) ? blogAltTag : `[[{"value":"{{${blogAltTagList[0]['content']}}}"}]] - [[{"value":"{{${blogAltTagList[1]['content']}}}"}]]`, // blog
      proFileTag: Boolean(proFileTag) ? proFileTag : `[[{"value":"{{${productFileList[0]['content']}}}"}]] - [[{"value":"{{${productFileList[4]['content']}}}"}]]`, // product
      colFileTag: Boolean(colFileTag) ? colFileTag : `[[{"value":"{{${colFileTagList[0]['content']}}}"}]] - [[{"value":"{{${colFileTagList[1]['content']}}}"}]]`, // collection
      blogFileTag: Boolean(blogFileTag) ? blogFileTag : `[[{"value":"{{${blogFileTagList[0]['content']}}}"}]] - [[{"value":"{{${blogFileTagList[1]['content']}}}"}]]`, // blog
    }
    this.setState({
      proAltTag: allTagList['proAltTag'],
      colAltTag: allTagList['colAltTag'],
      blogAltTag: allTagList['blogAltTag'],
      proFileTag: allTagList['proFileTag'],
      colFileTag: allTagList['colFileTag'],
      blogFileTag: allTagList['blogFileTag'],
      allTagList,
    })
  }

  // 转成tag输入框的数据格式
  setDefaultTagFormat = (type, data) => {
    let val = "";
    if (Boolean(data) && data !== '') {
      val = cloneDeep(data);
      val = val.replace(/\n/g, '');
      if (type === 'product') {
        val = val.replace(/%product_title%/g, '[[{"value":"{{Product title}}"}]]')
          .replace(/%product_vendor%/g, '[[{"value":"{{Product vendor}}"}]]')
          .replace(/%product_type%/g, '[[{"value":"{{Product type}}"}]]')
          .replace(/%shop_name%/g, '[[{"value":"{{Shop name}}"}]]')
          .replace(/%price%/g, '[[{"value":"{{Price}}"}]]')
          .replace(/%product_variant%/g, '[[{"value":"{{Product variant}}"}]]');
      } else if (type === 'collection') {
        val = val.replace(/%collection_title%/g, '[[{"value":"{{Collection title}}"}]]')
          .replace(/%shop_name%/g, '[[{"value":"{{Shop name}}"}]]');
      } else if (type === 'blog') {
        val = val.replace(/%blog_title%/g, '[[{"value":"{{Blog title}}"}]]')
          .replace(/%shop_name%/g, '[[{"value":"{{Shop name}}"}]]');
      } else { }
    }

    return val;
  }

  // 比特转换
  changeBitInfo = (limit) => {
    let size = "";
    if (limit < 1 * 1024 * 1024) {
      //小于0.1MB，则转化成KB 
      size = (limit / 1024).toFixed(2) + "KB"
    } else if (limit < 1 * 1024 * 1024 * 1024) {
      //小于0.1GB，则转化成MB 
      size = (limit / (1024 * 1024)).toFixed(2) + "MB"
    } else {
      //其他转化成GB 
      size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
    }
    return size;
  }

  //拖动条
  handleRangeSliderChange = (value, name) => {
    this.setState({
      [name]: value,
      setSaveDisabled: false,
    }, () => {
      if (name === 'imageCompressionLevel') {
        let arr = {
          custom: 1,
          lossless: 0,
          custom_ratio: value === 1 ? 90 : value === 2 ? 75 : value === 3 ? 70 : 75,
        }
        this.setState({
          imageCompressionLevelArr: arr
        })
      }
    });
  }

  //上传图片
  updateImageDrop = (files, acceptedFiles, rejectedFiles) => {
    this.setState({
      files: acceptedFiles[0],
      loadingLogo: true,
    }, () => {
      // 类型判断
      if (acceptedFiles.length === 0) {
        this.setState({
          errorImage: "File type must be .jpg .jpeg .png."
        })
      } else {
        if (acceptedFiles[0].type.indexOf('image') === -1 || !['jpg', 'jpeg', 'png'].includes(acceptedFiles[0].type.split('/')[1])) {
          this.setState({
            errorImage: "File type must be .jpg .jpeg .png."
          })
          // this.props.toggleToast(t("File type must be .jpg .jpeg .png."), true);
        } else if (acceptedFiles.length > 0 && acceptedFiles[0].size > 500 * 1024) {
          // 大于500kb提示
          this.setState({
            showToast: false,
            errorImage: 'watermark picture maximum size 500kb'
          })
          // this.props.toggleToast('watermark picture maximum size 500kb', true);
        } else {
          this.setState({
            setSaveDisabled: false,
          }, () => {
            this.handleDropImage(1, acceptedFiles[0]);
          })
        }
      }
    });
  };

  //图片数据加载
  handleDropImage = (type, acceptedFiles, img) => {
    let fileUpload = '';
    let uploadedFiles = '';
    let setUpdateImageWarning = '';
    let imageAddWatermarkImg = ""
    if (img) {
      fileUpload = !img && <DropZone.FileUpload actionTitle={t("Add file")} actionHint="(Maximum size 500kb)" />;
      if (!img) {
        this.setState({
          showImageUploadBanner: true
        })
      }
      uploadedFiles = img && (
        <div className="addImage addImageBox">
          <Thumbnail
            size="small"
            alt=''
            source={TEMPLATE_URL + img}
          />
        </div>
      );
      this.setState({
        imgButton: false,
        fileUpload: fileUpload,
        uploadedFiles: uploadedFiles,
        setUpdateImageWarning: "",
        showImageUploadBanner: false,
      });
    } else if (acceptedFiles) {
      const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
      const filesImg = acceptedFiles
      if (validImageTypes.indexOf(filesImg.type) >= 0) {
        let imageData = [];
        fileUpload = !filesImg && <DropZone.FileUpload actionTitle={t("Add file")} actionHint="(Maximum size 500kb)" />;
        if (!filesImg) {
          this.setState({
            showImageUploadBanner: true
          })
        }
        //开启FileReader
        let reader = new FileReader();
        reader.readAsDataURL(filesImg); //读取文件保存在result中
        reader.onload = (e) => {
          let getRes = e.target.result;//读取的结果在result中
          imageData.push(
            {
              'name': filesImg.name,
              'image': getRes,
              'type': filesImg.type,
            }
          );

          uploadedFiles = filesImg && (
            <div className="addHerpImage">
              <Thumbnail
                size="small"
                alt=""
                source={getRes}
              />
            </div>
          );
          imageAddWatermarkImg = getRes;

          this.setState({
            imgButton: false,
            fileUpload: fileUpload,
            uploadedFiles: uploadedFiles,
            imageAddWatermarkImg: imageAddWatermarkImg,
            setUpdateImageWarning: "",
            imageData: imageData,
            showImageUploadBanner: false,
          });
        }
      } else {
        fileUpload = <DropZone.FileUpload actionTitle={t("Add file")} actionHint="(Maximum size 500kb)" />;
        uploadedFiles = ''
        setUpdateImageWarning = <Banner title={t("The following images couldn't be uploaded:")}
          tone="critical"
          onDismiss={() => {
            this.setState({
              setUpdateImageWarning: null
            })
          }}
          action={{
            content: t("Contact us"),
            onAction: this.handleContactService
          }}
        >
          <List>
            <List.Item>
              {t("File type must be .jpg .jpeg .png.")}
            </List.Item>
          </List>
          <p></p>
        </Banner>
        this.setState({
          fileUpload: fileUpload,
          uploadedFiles: uploadedFiles,
          setUpdateImageWarning: setUpdateImageWarning,
          imageAddWatermarkImg: imageAddWatermarkImg,
          showImageUploadBanner: true,
        });
      }
    } else {
      fileUpload = <DropZone.FileUpload actionTitle={t("Add file")} actionHint="(Maximum size 500kb)" />;
      uploadedFiles = ''
      //如果提交的文件不是图片 就提醒报错
      if (type === 1) {
        setUpdateImageWarning = <Banner title={t("The following images couldn't be uploaded:")}
          tone="critical"
          onDismiss={() => {
            this.setState({
              setUpdateImageWarning: null
            })
          }}
          action={{
            content: t("Contact us"),
            onAction: this.handleContactService
          }}
        >
          <List>
            <List.Item>
              {t("File type must be .jpg .jpeg .png.")}
            </List.Item>
          </List>
        </Banner>
      }
      if (Number(this.state.imageAddWatermarkSwitch)) {
        this.setState({
          fileUpload: fileUpload,
          uploadedFiles: uploadedFiles,
          setUpdateImageWarning: setUpdateImageWarning,
          imageAddWatermarkImg: imageAddWatermarkImg,
          showImageUploadBanner: true
        });
      } else {
        this.setState({
          fileUpload: fileUpload,
          uploadedFiles: uploadedFiles,
          setUpdateImageWarning: setUpdateImageWarning,
          imageAddWatermarkImg: imageAddWatermarkImg,
        });
      }
    }
  }
  //删除图片
  deleteImage = () => {
    this.setState({
      files: '',
      imgButton: true,
      dataHasChange: true,
      showImageUploadBanner: true,
      imageAddWatermarkImg: '',

    }, () => {
      this.handleDropImage();
    });
  }

  //下拉框
  handleSelectChange = (e) => {
    this.setState({
      imageAddWatermarkPosition: e,
      setSaveDisabled: false,
    });
  }

  // 状态切换 正负
  handleStateChange = (name, val) => {
    let { isNewUserState } = this.state;
    if (name === "isShowImgFilename" && isNewUserState && Boolean(val)) {
      this.setState({
        isShowFileExistModal: true,
      })
    } else {
      this.setState({
        [name]: val,
      })

      // 首次设置
      if (name === 'firstSetSheetActive') {
        setTimeout(() => {
          this.setState({
            isShowSheetLoading: true,
          })
        }, 300)
      }

      // 抽屉弹窗
      if (['isShowImgCompression', 'AddWaterImg', 'isShowImgAltText', 'isShowImgFilename'].includes(name)) {
        this.setState({
          setSaveDisabled: false,
          isNewUserState: name === 'isShowImgFilename' ? true : isNewUserState,
        }, () => {
          let typeCol = `${name === 'AddWaterImg' ? 'isShowImgWatermark' : name}Col`;
          if (val) {
            this.setState({
              [typeCol]: true
            })
          }
        })
      }

      // 手动弹窗
      if (name === 'isShowManuallyModal') {
        this.setState({
          mPage: 1,
          mPageSize: 10,
          manuallyTabKey: 0,
          manuallyQueryVal: '',
        })
      }
    }
  }

  // 选择对应字段
  addApplyField = (type, name) => {
    let { proAltTag, colAltTag, blogAltTag, proFileTag, colFileTag, blogFileTag } = this.state;
    // 删除对应提示
    let curActive = cloneDeep(this.state.tagActive);
    if (curActive.includes(name)) {
      curActive.splice(curActive.indexOf(name), 1);
    }
    // 对象赋值
    let setObj =
      name === 'ProductAltFixTag' ? {
        proAltTag: !Boolean(proAltTag?.length) ? `[[{"value":"{{${type}}}"}]]` : `${proAltTag} [[{"value":"{{${type}}}"}]]`,
        addTagsProAlt: !Boolean(proAltTag?.length) ? `[[{"value":"{{${type}}}"}]]` : `${proAltTag} [[{"value":"{{${type}}}"}]]`
      } :
        name === 'ColAltFixTag' ? {
          colAltTag: !Boolean(colAltTag?.length) ? `[[{"value":"{{${type}}}"}]]` : `${colAltTag} [[{"value":"{{${type}}}"}]]`,
          addTagsColAlt: !Boolean(colAltTag?.length) ? `[[{"value":"${type}"}]]` : `${colAltTag} [[{"value":"${type}"}]]`,
        } :
          name === 'BlogAltFixTag' ? {
            blogAltTag: !Boolean(blogAltTag?.length) ? `[[{"value":"{{${type}}}"}]]` : `${blogAltTag} [[{"value":"{{${type}}}"}]]`,
            addTagsBlogAlt: !Boolean(blogAltTag?.length) ? `[[{"value":"{{${type}}}"}]]` : `${blogAltTag} [[{"value":"{{${type}}}"}]]`,
          } :
            name === 'ProductFileFixTag' ? {
              proFileTag: !Boolean(proFileTag?.length) ? `[[{"value":"{{${type}}}"}]]` : `${proFileTag} [[{"value":"{{${type}}}"}]]`,
              addTagsProFile: !Boolean(proFileTag?.length) ? `[[{"value":"{{${type}}}"}]]` : `${proFileTag} [[{"value":"{{${type}}}"}]]`,
            } :
              name === 'ColFileFixTag' ? {
                colFileTag: !Boolean(colFileTag?.length) ? `[[{"value":"{{${type}}}"}]]` : `${colFileTag} [[{"value":"{{${type}}}"}]]`,
                addTagsColFile: !Boolean(colFileTag?.length) ? `[[{"value":"{{${type}}}"}]]` : `${colFileTag} [[{"value":"{{${type}}}"}]]`,
              } :
                name === 'BlogFileFixTag' ? {
                  blogFileTag: !Boolean(blogFileTag?.length) ? `[[{"value":"{{${type}}}"}]]` : `${blogFileTag} [[{"value":"{{${type}}}"}]]`,
                  addTagsBlogFile: !Boolean(blogFileTag?.length) ? `[[{"value":"{{${type}}}"}]]` : `${blogFileTag} [[{"value":"{{${type}}}"}]]`,
                } : {};

    setObj[`${name}Pop`] = !Boolean(this.state[`${name}Pop`]);
    setObj['tagActive'] = curActive;
    setObj['setSaveDisabled'] = false;
    this.setState(setObj);
  }

  // 获取tag输入框对象
  setTagifyData = (data, name) => {
    this.setState({
      [name]: data[0],
    })
    this.$name = data[1];
  }

  // 输入
  tagInputData = debounce((e, name) => {
    let { allowList } = this.state;
    let curActive = cloneDeep(this.state.tagActive);
    const tagCompare = {
      proAltTag: "ProductAltFixTag",
      colAltTag: "ColAltFixTag",
      blogAltTag: "BlogAltFixTag",
      proFileTag: "ProductFileFixTag",
      colFileTag: "ColFileFixTag",
      blogFileTag: "BlogFileFixTag",
    }
    if (curActive.includes(tagCompare[name])) {
      curActive.splice(curActive.indexOf(tagCompare[name]), 1);
    }
    let value = "";
    if (e.type === "input") {
      value = e.detail.textContent;
      if (e.detail.tagify.value.length > 0) {
        e.detail.tagify.value.forEach(item => {
          let isExist = allowList.some(tag => item.value.includes(tag));
          if (isExist) {
            value = value.replace(new RegExp(`([^"])${item.value}([^"])`, 'g'), `$1[[{"value":"${item.value}"}]]$2`)
          } else {
            value = value.replace(new RegExp(`(?<!")${item.value}(?!")`, 'g'), item.value)
          }
        })
      }
    } else {
      const formattedValue = utils.normalizeMixValue(e.detail?.value || '', allowList);
      value = formattedValue;
      if (e.type === "remove") {
        const rvFormattedValue = utils.normalizeMixValue(e.detail.tagify?.state?.lastOriginalValueReported || '', allowList);
        value = rvFormattedValue;
      }
    }
    this.setState({
      [name]: Boolean(value) ? value.replace(/[\n\u200B]/g, "") : '',
      tagActive: curActive,
      setSaveDisabled: false,
    })
  }, 100)

  // 无痕模式 - 输入
  tagInputDataTraceless = (val, name) => {
    let curActive = cloneDeep(this.state.tagActive);
    const tagCompare = {
      proAltTag: "ProductAltFixTag",
      colAltTag: "ColAltFixTag",
      blogAltTag: "BlogAltFixTag",
      proFileTag: "ProductFileFixTag",
      colFileTag: "ColFileFixTag",
      blogFileTag: "BlogFileFixTag",
    }
    if (curActive.includes(tagCompare[name])) {
      curActive.splice(curActive.indexOf(tagCompare[name]), 1);
    }
    let tagType = ['proAltTag', 'proFileTag'].includes(name) ? 'product' : ['colAltTag', 'colFileTag'].includes(name) ? 'collection' : 'blog';
    let tagVal = this.setDefaultTagFormat(tagType, val);
    this.setState({
      [name]: Boolean(tagVal) ? tagVal.replace(/[\n\u200B]/g, "") : '',
      tagActive: curActive,
      setSaveDisabled: false,
    })
  }

  // 改变tag下拉框状态
  changeSelectPop = (id) => {
    let name = `${id}Pop`;
    const tagState = {
      ProductAltFixTagPop: false,
      ColAltFixTagPop: false,
      BlogAltFixTagPop: false,
      ProductFileFixTagPop: false,
      ColFileFixTagPop: false,
      BlogFileFixTagPop: false,
    }
    tagState[name] = !Boolean(this.state[name]);
    this.setState(tagState);
  }

  // 格式化tag数据
  changeTagFormat = (type, data) => {
    let val = cloneDeep(data);
    val = val.replace(/\n/g, '');
    if (type === 'product') {
      val = val.replace(/\[\[{"value":"{{Product title}}"}\]\]/g, '%product_title%')
        .replace(/\[\[{"value":"{{Product vendor}}"}\]\]/g, '%product_vendor%')
        .replace(/\[\[{"value":"{{Product type}}"}\]\]/g, '%product_type%')
        .replace(/\[\[{"value":"{{Shop name}}"}\]\]/g, '%shop_name%')
        .replace(/\[\[{"value":"{{Price}}"}\]\]/g, '%price%')
        .replace(/\[\[{"value":"{{Product variant}}"}\]\]/g, '%product_variant%');
    } else if (type === 'collection') {
      val = val.replace(/\[\[{"value":"{{Collection title}}"}\]\]/g, '%collection_title%')
        .replace(/\[\[{"value":"{{Shop name}}"}\]\]/g, '%shop_name%');
    } else if (type === 'blog') {
      val = val.replace(/\[\[{"value":"{{Blog title}}"}\]\]/g, '%blog_title%')
        .replace(/\[\[{"value":"{{Shop name}}"}\]\]/g, '%shop_name%');
    } else { }

    return val;
  }


  // 设置 check
  changeCheckState = (val, name) => {
    this.setState({
      setSaveDisabled: false,
    }, () => {
      if (name.indexOf('product') > -1) {
        let names = name.split('-')[0];
        this.setState({
          [names]: !Boolean(val) ? 0 : (name.indexOf('One') > -1 && Boolean(val)) ? 1 : 2,
        })
      } else if (name === 'ConvertImg_item') {
        this.setState({
          ConvertImg: Boolean(val)
        })
      } else if (name === 'AddWaterImg') {
        this.setState({
          showImageUploadBanner: val,
          [name]: Boolean(val)
        }, () => {
          if (!Boolean(val)) {
            this.deleteImage();
            this.setState({
              imageAddWatermarkImg: ''
            })
          }
        })
      } else {
        this.setState({
          [name]: Boolean(val)
        })
      }
    })
  }

  // 返回
  goBackImageOpt = (leave = 0) => {
    let { isGuideTip, setSaveDisabled, isShowImgCompression, productImg, ColImg, BlogImg, isShowImgAltText, productAlt, ColAlt, BlogAlt, isShowImgFilename, productFile, ColFile, BlogFile, AddWaterImg, showImageUploadBanner, imageAddWatermarkImg } = this.state;
    let stateSave = setSaveDisabled || (
      (Boolean(isShowImgCompression) && !Boolean(productImg) && !Boolean(ColImg) && !Boolean(BlogImg)) ||
      (Boolean(isShowImgAltText) && !Boolean(productAlt) && !Boolean(ColAlt) && !Boolean(BlogAlt)) ||
      (Boolean(isShowImgFilename) && !Boolean(productFile) && !Boolean(ColFile) && !Boolean(BlogFile))
    ) || (AddWaterImg && showImageUploadBanner && !Boolean(imageAddWatermarkImg));
    if (leave === 1 || stateSave) {
      utils.routeJump(this, '/speedOpt/PageSpeed', null, isGuideTip ? "showPopover" : "")
    } else {
      this.setState({
        isShowSaveTip: true
      })
    }
  }

  // 保存设置
  saveSetData = async (type) => {
    let {
      auto_switch,
      is_default,
      // image_opt,
      isShowImgCompression,
      isShowImgAltText,
      isShowImgFilename,
      productImg,
      ColImg,
      BlogImg,
      ConvertImg,
      AddWaterImg,
      imageAddWatermarkPosition,
      imageAddWatermarkSize,
      imageAddWatermarkOpacity,
      productAlt,
      ColAlt,
      BlogAlt,
      blankImgAlt,
      productFile,
      ColFile,
      BlogFile,
      proAltTag,
      colAltTag,
      blogAltTag,
      proFileTag,
      colFileTag,
      blogFileTag,
      imageAddWatermarkImg,
      imageData,
      imageCompressionLevelArr,
      ConvertImgJPG,

    } = this.state;
    // 判断是否自动开关还是设置保存
    let params = {};
    if (type === 'switch') {
      params = {
        auto_switch: Number(auto_switch),
      }
    } else {
      // 保存前校验：保存不了的原因统一通过对应提示 banner 展示，重新唤起被关闭的提示
      const compressionInvalid = Boolean(isShowImgCompression) && !Boolean(productImg) && !Boolean(ColImg) && !Boolean(BlogImg);
      const altInvalid = Boolean(isShowImgAltText) && !Boolean(productAlt) && !Boolean(ColAlt) && !Boolean(BlogAlt);
      const fileInvalid = Boolean(isShowImgFilename) && !Boolean(productFile) && !Boolean(ColFile) && !Boolean(BlogFile);
      const watermarkInvalid = Boolean(AddWaterImg) && !Boolean(imageAddWatermarkImg);
      if (compressionInvalid || altInvalid || fileInvalid || watermarkInvalid) {
        // 移除对应的关闭状态，让「至少设置一项」提示 banner 重新展示
        const nextEditTip = cloneDeep(this.state.isShowEditTip).filter((i) => {
          if (i === 1 && compressionInvalid) return false;
          if (i === 2 && altInvalid) return false;
          if (i === 3 && fileInvalid) return false;
          return true;
        });
        this.setState({
          isShowEditTip: nextEditTip,
          // 水印缺图：重新展示「Watermark image must be uploaded to save」提示并高亮上传区域
          ...(watermarkInvalid ? { isShowWatermarkTip: true, showImageUploadBanner: true } : {}),
        });
        return false;
      }
      let tagActive = [];
      if (isShowImgAltText) {
        if (productAlt && !Boolean(proAltTag.replace(/[\s\n\u200B]/g, ""))) {
          tagActive.push('ProductAltFixTag');
        }
        if (ColAlt && !Boolean(colAltTag.replace(/[\s\n\u200B]/g, ""))) {
          tagActive.push('ColAltFixTag');
        }
        if (BlogAlt && !Boolean(blogAltTag.replace(/[\s\n\u200B]/g, ""))) {
          tagActive.push('BlogAltFixTag');
        }
      }
      if (isShowImgFilename) {
        if (productFile && !Boolean(proFileTag.replace(/[\s\n\u200B]/g, ""))) {
          tagActive.push('ProductFileFixTag');
        }
        if (ColFile && !Boolean(colFileTag.replace(/[\s\n\u200B]/g, ""))) {
          tagActive.push('ColFileFixTag');
        }
        if (BlogFile && !Boolean(blogFileTag.replace(/[\s\n\u200B]/g, ""))) {
          tagActive.push('BlogFileFixTag');
        }
      }
      this.setState({
        tagActive,
      })
      if (tagActive.length > 0) {
        // this.props.toggleToast('The input value cannot be empty', false);
        return false;
      }
      params = {
        alt_text: {
          blogs: Number(BlogAlt),
          switch: Number(isShowImgAltText),
          product: Number(Boolean(productAlt) ? productAlt : 0),
          blogs_rule: this.changeTagFormat('blog', blogAltTag),
          collection: Number(ColAlt),
          product_rule: this.changeTagFormat('product', proAltTag),
          blank_replace: Number(blankImgAlt),
          collection_rule: this.changeTagFormat('collection', colAltTag),
        },
        file_name: {
          blogs: Number(BlogFile),
          switch: Number(isShowImgFilename),
          product: Number(Boolean(productFile) ? productFile : 0),
          blogs_rule: this.changeTagFormat('blog', blogFileTag),
          collection: Number(ColFile),
          product_rule: this.changeTagFormat('product', proFileTag),
          collection_rule: this.changeTagFormat('collection', colFileTag)
        },
        is_default: is_default,
        auto_switch: Number(auto_switch),
        image_opt: {
          switch: Number(isShowImgCompression),
          product: Number(Boolean(productImg) ? productImg : 0),
          collection: Number(ColImg),
          blogs: Number(BlogImg),
          pngtojpg: Number(ConvertImg),
          pngtojpg_size_control: Number(ConvertImgJPG),
          quality: imageCompressionLevelArr,
          watermark: {
            switch: Number(AddWaterImg),
            logo: imageAddWatermarkImg,
            // file_data: imageAddWatermarkImg,
            // file_name: Boolean(imageData) && imageData.length > 0 ? imageData[0].name : '',
            position: imageAddWatermarkPosition,
            image_height: Number(Number(imageAddWatermarkSize / 100).toFixed(2)),
            opacity: Number(imageAddWatermarkOpacity)
          }
        }
      }
      if (imageAddWatermarkImg.indexOf('base64') > -1) {
        params['image_opt']['watermark']['file_data'] = imageAddWatermarkImg;
        params['image_opt']['watermark']['file_name'] = Boolean(imageData) && imageData.length > 0 ? imageData[0].name : '';
        params['image_opt']['watermark']['logo'] = "";
      }
    }
    this.setState({
      setSaveLoading: true,
    })
    const res = await reqSaveSettings(params);
    if (res.ack === 1) {
      this.props.toggleToast(res.msg, false);
      this.setState({
        setSaveDisabled: true,
        setSaveLoading: false,
      }, () => {
        this.getProductStatistics(params['is_default'] ? true : false);
      })
    } else {
      this.props.toggleToast(res.msg, true);
      this.setState({
        setSaveDisabled: false,
        setSaveLoading: false,
      })
    }

    return res;
  }

  // 需要做源数据快照/回退的表单字段
  formSnapshotKeys = [
    'isShowImgCompression', 'productImg', 'ColImg', 'BlogImg', 'ConvertImg', 'ConvertImgJPG',
    'AddWaterImg', 'imageAddWatermarkImg', 'imageAddWatermarkPosition', 'imageAddWatermarkSize', 'imageAddWatermarkOpacity',
    'imageCompressionLevel', 'imageCompressionLevelArr',
    'isShowImgAltText', 'productAlt', 'ColAlt', 'BlogAlt', 'blankImgAlt', 'proAltTag', 'colAltTag', 'blogAltTag',
    'isShowImgFilename', 'productFile', 'ColFile', 'BlogFile', 'proFileTag', 'colFileTag', 'blogFileTag',
  ];

  // 生成当前表单源数据快照
  getFormSnapshot = () => {
    const snapshot = {};
    this.formSnapshotKeys.forEach((key) => {
      snapshot[key] = cloneDeep(this.state[key]);
    });
    return snapshot;
  }

  // 舍弃未保存的修改（回退到源数据快照，不重新请求接口）
  handleDiscardAction = () => {
    const { originSetData } = this.state;
    if (!originSetData) return;
    this.setState({
      ...cloneDeep(originSetData),
      tagActive: [],
      setSaveDisabled: true,
    }, () => {
      // 还原水印图片预览
      this.handleDropImage(0, '', originSetData.imageAddWatermarkImg);
    })
  }

  //点击联系客服
  handleContactService = () => {
    try {
      showNewMessage()
    } catch (e) {
      this.props.toggleToast(t("Try again later"), true);
    }
  }

  // 关闭没有填写提示
  closeNotEditTip = (i) => {
    let curIndex = cloneDeep(this.state.isShowEditTip);
    curIndex.push(i);
    this.setState({
      isShowEditTip: curIndex
    })
  }

  // 关闭保存提示
  closeSaveTip = () => {
    this.setState({
      isShowSaveTip: false,
    })
  }

  // 打开关闭
  toggleCollBox = (type) => {
    this.setState({
      [type]: !this.state[type]
    })
  }

  // 跳转
  jumpAltPage = () => {
    utils.routeJump(this, '/on-page-seo/image-alt-text')
  }

  // 启用文件存在
  handleEnableFileExist = () => {
    this.setState({
      isNewUserState: false,
      isShowFileExistModal: false,
    }, () => {
      this.handleStateChange('isShowImgFilename', true)
    })
  }

  // 监听状态
  listenTagifyBlurStatus = (_state = false) => {
    this.setState({
      isBlur: _state,
    })
  }

  render() {
    const {
      isShowImgCompression,
      isShowImgAltText,
      isShowImgFilename,
      productImg,
      ColImg,
      BlogImg,
      // ConvertImg,
      AddWaterImg,
      productAlt,
      ColAlt,
      BlogAlt,
      blankImgAlt,
      productFile,
      ColFile,
      BlogFile,
      setSaveLoading,
      setSaveDisabled,
      proAltTag,
      colAltTag,
      blogAltTag,
      proFileTag,
      colFileTag,
      blogFileTag,
      productAltList,
      colAltTagList,
      blogAltTagList,
      productFileList,
      colFileTagList,
      blogFileTagList,
      isShowSheetLoading,
      showImageUploadBanner,
      imageAddWatermarkImg,
      setUpdateImageWarning,
      uploadedFiles,
      fileUpload,
      imgButton,
      imageAddWatermarkPosition,
      imageAddWatermarkSize,
      imageAddWatermarkOpacity,
      tagActive,
      ProductAltFixTagPop,
      ColAltFixTagPop,
      BlogAltFixTagPop,
      ProductFileFixTagPop,
      ColFileFixTagPop,
      BlogFileFixTagPop,
      addTagsProAlt,
      addTagsColAlt,
      addTagsBlogAlt,
      addTagsProFile,
      addTagsColFile,
      addTagsBlogFile,
      isLocalStorage,
      errorImage,
      isShowEditTip,
      isShowWatermarkTip,
      isShowCompressionLevel,
      imageCompressionLevel,
      // isShowImgWatermark,

      isShowImgCompressionCol,
      isShowImgWatermarkCol,
      isShowImgAltTextCol,
      isShowImgFilenameCol,
      watermarkUrl,
      isShowSaveTip,
      // ConvertImgJPG,
      isShowFileExistModal,
      isShowFileOpt,
      isBlur,

    } = this.state;

    // 保存提示
    const SaveTipModal = <Modal
      title={t("Leave Confirmation")}
      open={isShowSaveTip}
      primaryAction={{
        content: t("Stay on this page"),
        onAction: this.closeSaveTip,
      }}
      secondaryActions={[
        {
          content: t("Leave"),
          onAction: () => this.goBackImageOpt(1)
        }
      ]}
      onClose={this.closeSaveTip}
    >
      <div style={{ padding: '1rem' }}>{t("Your changes have not been saved. Are you sure you want to leave?")}</div>
    </Modal>

    // 首次设置抽屉
    const warnIcon = <svg t="1695125243916" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11078" width="20" height="20"><path d="M959.256366 512C959.256366 264.98713 759.01287 64.743634 512 64.743634 264.98713 64.743634 64.743634 264.98713 64.743634 512 64.743634 759.01287 264.98713 959.256366 512 959.256366 759.01287 959.256366 959.256366 759.01287 959.256366 512L959.256366 512 959.256366 512 959.256366 512 959.256366 512 959.256366 512ZM117.36203 512C117.36203 294.047467 294.047467 117.36203 512 117.36203 729.952533 117.36203 906.63797 294.047467 906.63797 512 906.63797 729.952533 729.952533 906.63797 512 906.63797 294.047467 906.63797 117.36203 729.952533 117.36203 512L117.36203 512 117.36203 512 117.36203 512 117.36203 512 117.36203 512Z" fill="#FC5143" p-id="11079"></path><path d="M484.457558 599.560299C484.457558 622.580963 495.008537 634.091122 516.110812 634.091122 537.213087 634.091122 547.764066 622.580963 547.764066 599.560299L547.764066 280.150193C547.764066 257.129529 537.213087 245.61937 516.110812 245.61937 495.008537 245.61937 484.457558 257.129529 484.457558 280.150193L484.457558 599.560299ZM478.702421 740.561158C480.62081 763.581821 493.090149 775.091981 516.110812 775.091981 539.131476 775.091981 551.600815 763.581821 553.519203 740.561158 551.600815 717.540494 539.131476 705.071155 516.110812 703.152767 493.090149 705.071155 480.62081 717.540494 478.702421 740.561158L478.702421 740.561158Z" fill="#FC5143" p-id="11080"></path></svg>
    const TipBannerSet = (index) => {
      return <div className='tip_banner_setting'>
        <Banner
          title={t("Optimization cannot occur until you have set up at least one item.")}
          tone='warning'
          action={{
            content: t("Contact us"),
            onAction: this.handleContactService
          }}
          onDismiss={() => this.closeNotEditTip(index)}
        >
        </Banner>
      </div>
    }

    // 文件存在弹窗
    const FileExistModal = <Modal
      title={t("Changing image filenames may break existing links")}
      open={isShowFileExistModal}
      primaryAction={{
        content: t("Enable"),
        onAction: () => this.handleEnableFileExist()
      }}
      secondaryActions={[
        {
          content: t("Cancel"),
          onAction: () => this.setState({ isShowFileExistModal: false })
        }
      ]}
      onClose={() => this.setState({ isShowFileExistModal: false })}
    >
      <Modal.Section>
        <p>{t("Renaming image filenames will change their URLs, which may break existing links. Please make sure your website or ads don't directly use hard-coded image URLs before enabling this feature.")}</p>
      </Modal.Section>
    </Modal>

    // 格式化数据
    const TracelessTagsData = (type, val) => {
      let formatVal = val.replace(/\n/g, '');
      if (['ProductAltFixTag', 'ProductFileFixTag'].includes(type)) {
        formatVal = formatVal.replace(/\[\[{"value":"{{Product title}}"}\]\]/g, '%product_title%')
          .replace(/\[\[{"value":"{{Product vendor}}"}\]\]/g, '%product_vendor%')
          .replace(/\[\[{"value":"{{Product type}}"}\]\]/g, '%product_type%')
          .replace(/\[\[{"value":"{{Shop name}}"}\]\]/g, '%shop_name%')
          .replace(/\[\[{"value":"{{Price}}"}\]\]/g, '%price%')
          .replace(/\[\[{"value":"{{Product variant}}"}\]\]/g, '%product_variant%');
      } else if (['ColAltFixTag', 'ColFileFixTag'].includes(type)) {
        formatVal = formatVal.replace(/\[\[{"value":"{{Collection title}}"}\]\]/g, '%collection_title%')
          .replace(/\[\[{"value":"{{Shop name}}"}\]\]/g, '%shop_name%');
      } else if (['BlogAltFixTag', 'BlogFileFixTag'].includes(type)) {
        formatVal = formatVal.replace(/\[\[{"value":"{{Blog title}}"}\]\]/g, '%blog_title%')
          .replace(/\[\[{"value":"{{Shop name}}"}\]\]/g, '%shop_name%');
      } else { }

      return formatVal;
    }

    // 水印模块
    const options = [
      { label: t("Top Left"), value: 't_l' },
      { label: t("Top Center"), value: 't_c' },
      { label: t("Top Right"), value: 't_r' },
      { label: t("Center"), value: 'c' },
      { label: t("Bottom Left"), value: 'b_l' },
      { label: t("Bottom Center"), value: 'b_c' },
      { label: t("Bottom Right"), value: 'b_r' },
    ];
    const tipBanner = AddWaterImg && !Boolean(imageAddWatermarkImg) && isShowWatermarkTip ? <Banner
      title={t("Watermark image must be uploaded to save")}
      tone="warning"
      onDismiss={() => {
        this.setState({
          isShowWatermarkTip: false,
        })
      }}
      action={{
        content: t("Contact us"),
        onAction: this.handleContactService
      }}
    ></Banner> : null;
    const is_imageAddWatermark = <div className='imageAddWatermarkContent'>
      <BlockStack gap={300}>
        <div>
          <div className="Polaris-Labelled__LabelWrapper"><div className="Polaris-Label"><label id="imageAddWatermarkOpacityLabel" htmlFor="imageAddWatermarkOpacity" className="Polaris-Label__Text">* {t("Upload Watermark Images")}</label></div></div>
          <div style={{ margin: '0.5rem 0' }}>
            {setUpdateImageWarning}
          </div>
          <div className='flex_layout water_upload'>
            <div className={showImageUploadBanner && !Boolean(imageAddWatermarkImg) ? 'DropZoneContent DropZoneContentError' : 'DropZoneContent'}>
              <DropZone
                // accept="image/png,image/jpeg,image/jpg"
                accept='image/*'
                type="image"
                // errorOverlayText="File type must be .jpg .jpeg .png."
                onDrop={this.updateImageDrop}
                variableHeight
              >
                {uploadedFiles}
                {fileUpload}
              </DropZone>
            </div>

            <div style={{ display: imgButton ? 'none' : 'block', marginBottom: '0.2rem' }}>
              <Button disabled={imgButton} onClick={() => this.deleteImage()}>{t("Remove")}</Button>
            </div>
          </div>
        </div>
        {tipBanner}
        <Select
          label={t("Watermark Position")}
          options={options}
          onChange={this.handleSelectChange}
          value={imageAddWatermarkPosition}
        />
        <div>
          <RangeSlider
            max={100}
            min={1}
            step={1}
            id="imageAddWatermarkSize"
            label={<span>
              <span>{t("Watermark Size")}</span>
              <span style={{ color: "#005BD3" }}>&nbsp;{(imageAddWatermarkSize.toFixed(0)) + "%"}&nbsp;</span>
              <span>{t("of the image height")}</span>
            </span>}
            value={imageAddWatermarkSize}
            onChange={this.handleRangeSliderChange}
            output
          />
        </div>
        <div>
          <RangeSlider
            max={1}
            min={0.1}
            step={0.1}
            id="imageAddWatermarkOpacity"
            label={t("Opacity")}
            value={imageAddWatermarkOpacity}
            onChange={this.handleRangeSliderChange}
            output
          />
          <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
            <div style={{ opacity: "0.1" }}><Badge>{t("Opacity")}</Badge></div>
            <div style={{ opacity: "0.5" }}><Badge>{t("Opacity")}</Badge></div>
            <div style={{ opacity: "1" }}><Badge>{t("Opacity")}</Badge></div>
          </div>
        </div>
      </BlockStack>
    </div>

    // 设置页面
    const settingMain = <div>
      {isShowSheetLoading ? <div className='sheet_loading_image'>
        <Spinner />
      </div> :
        <BlockStack gap={400}>
          <Card padding={0}>
            <div className='ImageSetItems ImageCompression_Box'>
              <div className='ImageSetTop' onClick={() => this.toggleCollBox('isShowImgCompressionCol')}>
                <BlockStack gap={100}>
                  <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
                    <div className='flex_layout'>
                      <Text variant="headingLg" as="h2">{t("Image compression")}</Text>
                      <Badge tone={isShowImgCompression ? 'success' : ''}>{isShowImgCompression ? t("On") : t("Off")}</Badge>
                    </div>
                    <div className='flex_layout' onClick={(e) => { e.stopPropagation() }}>
                      <Switch disabled={false} onChange={() => this.handleStateChange('isShowImgCompression', !isShowImgCompression)} checked={isShowImgCompression} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                    </div>
                  </div>
                  <Text as="p" color="subdued">{t("Compress images to improve loading page speed and enhance user experience.")}</Text>
                </BlockStack>
              </div>
              <div>
                {
                  (Boolean(isShowImgCompression) && !Boolean(productImg) && !Boolean(ColImg) && !Boolean(BlogImg) && !isShowEditTip.includes(1)) ? TipBannerSet(1) : null
                }
                <Collapsible
                  open={isShowImgCompressionCol}
                  id={`ImageCompression-collapsible`}
                  transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                  expandOnPrint
                >
                  <BlockStack gap={400}>
                    <div className='image_setting_content'>
                      <BlockStack gap={100}>
                        <Text variant="headingMd" as="h2">{t("Select Image sources to compress")}</Text>
                        <Text as="p" color="subdued">{t("Select which image types will be automatically optimized. This setting applies to Auto Optimization only.")}</Text>
                      </BlockStack>
                      <br />
                      <Checkbox
                        label={t("Product Images")}
                        id="productImg-Main"
                        checked={Boolean(productImg)}
                        onChange={this.changeCheckState}
                      />
                      <Collapsible
                        open={Boolean(productImg)}
                        id={`productImg-collapsible`}
                        transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                        expandOnPrint
                      >
                        <div className='flex_layout imgSet_item_first'>
                          <ChoiceList
                            id="productImg-One"
                            title=""
                            choices={[
                              { label: t("All Product Images"), value: '1' },
                            ]}
                            selected={`${productImg}`}
                            onChange={() => this.changeCheckState("1", "productImg-One")}
                          />
                          <ChoiceList
                            id="productImg-Two"
                            title=""
                            choices={[
                              { label: t("Only Active Product Images"), value: '2' },
                            ]}
                            selected={`${productImg}`}
                            onChange={() => this.changeCheckState("2", "productImg-Two")}
                          />
                        </div>
                      </Collapsible>
                      <div className='flex_layout imgSet_item'>
                        <Checkbox
                          label={t("Collection Images")}
                          id="ColImg"
                          checked={ColImg}
                          onChange={this.changeCheckState}
                        />
                      </div>
                      <div className='flex_layout imgSet_item'>
                        <Checkbox
                          label={t("Blog Post Images")}
                          id="BlogImg"
                          checked={BlogImg}
                          onChange={this.changeCheckState}
                        />
                      </div>
                      {/* {
                          (Boolean(productImg) || Boolean(ColImg) || Boolean(BlogImg)) ? <div>
                            <Text variant="headingMd" as="h2">{t("Format conversion")}</Text>
                            <div className='imgSet_item'>
                              <Checkbox
                                label={t("Convert PNG to JPG")}
                                id="ConvertImg"
                                checked={ConvertImg}
                                onChange={this.changeCheckState}
                              />
                            </div>
                            <div className='imgSet_item'>
                              <Checkbox
                                label={t("JPG conversion size control")}
                                id="ConvertImgJPG"
                                helpText={t("When converting to JPG, the converting process will stop if the converted image size starts to exceed the original image size (unchecking means continue to convert)")}
                                checked={ConvertImgJPG}
                                onChange={this.changeCheckState}
                              />
                            </div>
                            
                          </div> : null
                        } */}
                      <div className='compression_level'>
                        <BlockStack gap={100}>
                          <Text variant="headingMd" as="h2">{t("Compression level")}</Text>
                          {/* <div className='level_top flex_layout' onClick={() => this.setState({ isShowCompressionLevel: !isShowCompressionLevel })}>
                              <Icon source={isShowCompressionLevel ? ChevronUpMinor : ChevronDownMinor} />
                            </div> */}
                          <Collapsible
                            open={isShowCompressionLevel}
                            id={`CompressionLevel-collapsible`}
                            transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                            expandOnPrint
                          >
                            <BlockStack gap={100}>
                              <Text as="p" color="subdued">{t("Higher compression reduces file size and improves page speed, but may slightly affect image clarity.")}</Text>
                              <div className='level_items'>
                                <span>{t("Low")}</span>
                                <span className='level_mid'>{t("Medium")}&nbsp;&nbsp;<span className='level_recommend'>({t("Recommended")})</span></span>
                                <span>{t("High")}</span>
                              </div>
                              <div className='level_RangeSlider'>
                                <RangeSlider
                                  max={3}
                                  min={1}
                                  step={1}
                                  id="imageCompressionLevel"
                                  label={""}
                                  value={imageCompressionLevel}
                                  onChange={this.handleRangeSliderChange}
                                  output={false}
                                />
                              </div>
                              {/* <div className='level_items level_recommend'>
                                  <span>{t("Recommended")}</span>
                                </div> */}
                            </BlockStack>
                          </Collapsible>
                        </BlockStack>
                      </div>
                    </div>
                  </BlockStack>

                </Collapsible>
              </div>
            </div>
          </Card>
          <Card padding={0}>
            <div className='ImageSetItems ImageWatermark_Box'>
              <div className='ImageSetTop' onClick={() => this.toggleCollBox('isShowImgWatermarkCol')}>
                <BlockStack gap={100}>
                  <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
                    <div className='flex_layout'>
                      <Text variant="headingLg" as="h2">{t("Add Image watermark")}</Text>
                      <Badge tone={AddWaterImg ? 'success' : ''}>{AddWaterImg ? t("On") : t("Off")}</Badge>
                    </div>
                    <div className='flex_layout' onClick={(e) => { e.stopPropagation() }}>
                      <Switch disabled={false} onChange={() => this.handleStateChange('AddWaterImg', !AddWaterImg)} checked={AddWaterImg} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                    </div>
                  </div>
                  <Text as="p" color="subdued">{t("Add watermarks to protect your image copyrights and verify content authenticity. Supported formats: PNG and JPG only.")}</Text>
                </BlockStack>
              </div>
              <Collapsible
                open={isShowImgWatermarkCol}
                id={`ImageWatermark-collapsible`}
                transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                expandOnPrint
              >
                <BlockStack gap={200}>
                  <div className='image_setting_content'>
                    {/* <Text as="p" color="subdued">{t("Only PNG and JPG format images are allowed to add watermarks.")}</Text> */}
                    {
                      errorImage && <div style={{ margin: '0.6rem 0' }}>
                        <Banner
                          title={errorImage}
                          tone="warning"
                          onDismiss={() => {
                            this.setState({ errorImage: '' })
                          }}
                          action={{
                            content: t("Contact us"),
                            onAction: this.handleContactService
                          }}
                        >
                        </Banner>
                      </div>
                    }
                    <div className='watermark_main'>
                      {is_imageAddWatermark}
                      <div>
                        <Text variant="headingMd" as="h2">{t("Preview")}</Text>
                        <div className='watermark_view'>
                          <div className='image_main'>
                            <img className='watermarkBg' src='/imgs/ImageOpt/waterbgNew.png' alt='watermarkbg' />
                            <img className='watermarkUrl' style={
                              imageAddWatermarkPosition === 't_l' ? { top: 0, left: 0, opacity: imageAddWatermarkOpacity, height: `${280 * (imageAddWatermarkSize / 100)}px` } :
                                imageAddWatermarkPosition === 't_c' ? { top: 0, left: '50%', transform: 'translate(-50%, 0)', opacity: imageAddWatermarkOpacity, height: `${280 * (imageAddWatermarkSize / 100)}px` } :
                                  imageAddWatermarkPosition === 't_r' ? { top: 0, right: 0, opacity: imageAddWatermarkOpacity, height: `${280 * (imageAddWatermarkSize / 100)}px` } :
                                    imageAddWatermarkPosition === 'c' ? { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', opacity: imageAddWatermarkOpacity, height: `${280 * (imageAddWatermarkSize / 100)}px` } :
                                      imageAddWatermarkPosition === 'b_l' ? { bottom: 0, left: 0, opacity: imageAddWatermarkOpacity, height: `${280 * (imageAddWatermarkSize / 100)}px` } :
                                        imageAddWatermarkPosition === 'b_c' ? { bottom: 0, left: '50%', transform: 'translate(-50%, 0)', opacity: imageAddWatermarkOpacity, height: `${280 * (imageAddWatermarkSize / 100)}px` } :
                                          imageAddWatermarkPosition === 'b_r' ? { bottom: 0, right: 0, opacity: imageAddWatermarkOpacity, height: `${280 * (imageAddWatermarkSize / 100)}px` } : { opacity: imageAddWatermarkOpacity, height: `${280 * (imageAddWatermarkSize / 100)}px` }
                            } src={imageAddWatermarkImg ? `${imageAddWatermarkImg.includes('base64') ? imageAddWatermarkImg : TEMPLATE_URL + imageAddWatermarkImg}` : watermarkUrl} alt='watermarkUrl' />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </BlockStack>
              </Collapsible>
            </div>
          </Card>
          {
            false &&
            <Card>
              <div className='ImageSetItems ImageAltText_Box'>
                <div className='ImageSetTop' onClick={() => this.toggleCollBox('isShowImgAltTextCol')}>
                  <BlockStack gap={200}>
                    <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
                      <div className='flex_layout'>
                        <Text variant="headingLg" as="h2">{t("Add Image alt text")}</Text>
                        <Badge tone={isShowImgAltText ? 'success' : ''}>{isShowImgAltText ? t("On") : t("Off")}</Badge>
                      </div>
                      <div className='flex_layout' onClick={(e) => { e.stopPropagation() }}>
                        <Switch disabled={false} onChange={() => this.handleStateChange('isShowImgAltText', !isShowImgAltText)} checked={isShowImgAltText} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                      </div>
                    </div>
                    <Text as="p" color="subdued">{t("Alt text helps search engines understand the content of the image and can improve the accessibility and SEO of a website.")}</Text>
                  </BlockStack>
                </div>
                {
                  (Boolean(isShowImgAltText) && !Boolean(productAlt) && !Boolean(ColAlt) && !Boolean(BlogAlt) && !isShowEditTip.includes(2)) ? TipBannerSet(2) : null
                }
                <Collapsible
                  open={isShowImgAltTextCol}
                  id={`ImageAltText-collapsible`}
                  transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                  expandOnPrint
                >
                  <div className='imgSet_item'>
                    <Text variant="headingMd" as="h2">{t("Application range")}</Text>
                  </div>
                  <div className='imgSet_item'>
                    <Checkbox
                      label={t("All product image alt")}
                      id="productAlt-One"
                      checked={productAlt === 1}
                      onChange={this.changeCheckState}
                    />
                    <Checkbox
                      label={t("Only published product image alt")}
                      id="productAlt-Two"
                      checked={productAlt === 2}
                      onChange={this.changeCheckState}
                    />
                  </div>
                  <div className={`${Boolean(productAlt) ? 'imgSet_tag' : 'imgSet_tag_out'}`}>
                    <Collapsible
                      open={Boolean(productAlt)}
                      id={`productAlt-collapsible`}
                      transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                      expandOnPrint
                    >
                      {
                        Boolean(isLocalStorage) ? <>
                          <FreeTagInputMix
                            isBlur={isBlur}
                            id={"ProductAltFixTag"}
                            tagActive={tagActive}
                            defaultTag={proAltTag}
                            actionList={productAltList}
                            isShowSelectPop={ProductAltFixTagPop}
                            changeSelectPop={this.changeSelectPop}
                            tagInputData={(e) => this.tagInputData(e, 'proAltTag')}
                            addTags={addTagsProAlt}
                          />
                          {
                            (tagActive.length > 0 && tagActive.includes("ProductAltFixTag")) ? <div className='flex_layout warnTip'>
                              {warnIcon}
                              <span>{t("The input cannot be empty!")}</span>
                            </div> : null
                          }
                        </> :
                          <FreeTagInputTraceless
                            id={"ProductAltFixTag"}
                            tagActive={tagActive}
                            defaultTag={TracelessTagsData('ProductAltFixTag', proAltTag)}
                            actionList={productAltList}
                            isShowSelectPop={ProductAltFixTagPop}
                            changeSelectPop={this.changeSelectPop}
                            tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'proAltTag')}
                          />
                      }
                    </Collapsible>
                  </div>
                  <br />
                  <div className='imgSet_item'>
                    <Checkbox
                      label={t("Collection image alt")}
                      id="ColAlt"
                      checked={ColAlt}
                      onChange={this.changeCheckState}
                    />
                    <div className={`${ColAlt ? 'imgSet_tag' : 'imgSet_tag_out'}`}>
                      <Collapsible
                        open={ColAlt}
                        id={`ColAlt-collapsible`}
                        transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                        expandOnPrint
                      >
                        {
                          Boolean(isLocalStorage) ? <>
                            <FreeTagInputMix
                              isBlur={isBlur}
                              id={"ColAltFixTag"}
                              tagActive={tagActive}
                              defaultTag={colAltTag}
                              actionList={colAltTagList}
                              isShowSelectPop={ColAltFixTagPop}
                              changeSelectPop={this.changeSelectPop}
                              tagInputData={(e) => this.tagInputData(e, 'colAltTag')}
                              addTags={addTagsColAlt}
                            />
                            {
                              (tagActive.length > 0 && tagActive.includes("ColAltFixTag")) ? <div className='flex_layout warnTip'>
                                {warnIcon}
                                <span>{t("The input cannot be empty!")}</span>
                              </div> : null
                            }
                          </> :
                            <FreeTagInputTraceless
                              id={"ColAltFixTag"}
                              tagActive={tagActive}
                              defaultTag={TracelessTagsData('ColAltFixTag', colAltTag)}
                              actionList={colAltTagList}
                              isShowSelectPop={ColAltFixTagPop}
                              changeSelectPop={this.changeSelectPop}
                              tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'colAltTag')}
                            />
                        }
                      </Collapsible>
                    </div>
                  </div>
                  <div className='imgSet_item'>
                    <Checkbox
                      label={t("Blog post image alt")}
                      id="BlogAlt"
                      checked={BlogAlt}
                      onChange={this.changeCheckState}
                    />
                    <div className={`${BlogAlt ? 'imgSet_tag' : 'imgSet_tag_out'}`}>
                      <Collapsible
                        open={BlogAlt}
                        id={`BlogAlt-collapsible`}
                        transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                        expandOnPrint
                      >
                        {
                          Boolean(isLocalStorage) ? <>
                            <FreeTagInputMix
                              isBlur={isBlur}
                              id={"BlogAltFixTag"}
                              tagActive={tagActive}
                              defaultTag={blogAltTag}
                              actionList={blogAltTagList}
                              isShowSelectPop={BlogAltFixTagPop}
                              changeSelectPop={this.changeSelectPop}
                              tagInputData={(e) => this.tagInputData(e, 'blogAltTag')}
                              addTags={addTagsBlogAlt}
                            />
                            {
                              (tagActive.length > 0 && tagActive.includes("BlogAltFixTag")) ? <div className='flex_layout warnTip'>
                                {warnIcon}
                                <span>{t("The input cannot be empty!")}</span>
                              </div> : null
                            }
                          </> :
                            <FreeTagInputTraceless
                              id={"BlogAltFixTag"}
                              tagActive={tagActive}
                              defaultTag={TracelessTagsData('BlogAltFixTag', blogAltTag)}
                              actionList={blogAltTagList}
                              isShowSelectPop={BlogAltFixTagPop}
                              changeSelectPop={this.changeSelectPop}
                              tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'blogAltTag')}
                            />
                        }
                      </Collapsible>
                    </div>
                  </div>
                  <div className='row_line_1p5'></div>
                  <div className='imgSet_item'>
                    {
                      (Boolean(productAlt) || Boolean(ColAlt) || Boolean(BlogAlt)) ?
                        <Checkbox
                          label={t("Only for images without Alt text")}
                          id="blankImgAlt"
                          checked={blankImgAlt}
                          onChange={this.changeCheckState}
                          helpText={t("If checked, alt attributes will only be generated for images that are not optimized and do not have alt attributes. If unchecked, alt attributes will be generated for all unoptimized images.")}
                        /> : null
                    }
                  </div>
                </Collapsible>
              </div>
            </Card>
          }
          {
            (isShowFileOpt) && <Card padding={0}>
              <div className='ImageSetItems imageFilename_Box'>
                <div className='ImageSetTop' onClick={() => this.toggleCollBox('isShowImgFilenameCol')}>
                  <BlockStack gap={100}>
                    <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
                      <div className='flex_layout'>
                        <Text variant="headingLg" as="h2">{t("Optimize image filename")}</Text>
                        <Badge tone={isShowImgFilename ? 'success' : ''}>{isShowImgFilename ? t("On") : t("Off")}</Badge>
                      </div>
                      <div className='flex_layout' onClick={(e) => { e.stopPropagation() }}>
                        <Switch disabled={false} onChange={() => this.handleStateChange('isShowImgFilename', !isShowImgFilename)} checked={isShowImgFilename} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                      </div>
                    </div>
                    <Text as="p" color="subdued">{t("Select image resources and set naming rules to help search engines better understand your images.")}</Text>
                  </BlockStack>
                </div>
                {
                  (Boolean(isShowImgFilename) && !Boolean(productFile) && !Boolean(ColFile) && !Boolean(BlogFile) && !isShowEditTip.includes(3)) ? TipBannerSet(3) : null
                }
                <Collapsible
                  open={isShowImgFilenameCol}
                  id={`imageFilename-collapsible`}
                  transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                  expandOnPrint
                >
                  <div className='image_setting_content' onMouseEnter={() => this.listenTagifyBlurStatus(false)} onMouseLeave={() => this.listenTagifyBlurStatus(true)}>
                    <BlockStack gap={400}>
                      <Text variant="headingMd" as="h2">{t("Application range")}</Text>
                      <BlockStack gap={200}>
                        <Checkbox
                          label={t("Product Images")}
                          id="productFile-Main"
                          checked={productFile}
                          onChange={this.changeCheckState}
                        />
                        <div className={`${Boolean(productFile) ? 'imgSet_tag' : 'imgSet_tag_out'}`}>
                          <Collapsible
                            open={Boolean(productFile)}
                            id={`productFile-collapsible`}
                            transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                            expandOnPrint
                          >
                            {
                              Boolean(isLocalStorage) ? <>
                                <FreeTagInputMix
                                  isBlur={isBlur}
                                  id={"ProductFileFixTag"}
                                  tagActive={tagActive}
                                  defaultTag={proFileTag}
                                  actionList={productFileList}
                                  isShowSelectPop={ProductFileFixTagPop}
                                  changeSelectPop={this.changeSelectPop}
                                  tagInputData={(e) => this.tagInputData(e, 'proFileTag')}
                                  addTags={addTagsProFile}
                                />
                                {
                                  (tagActive.length > 0 && tagActive.includes("ProductFileFixTag")) ? <div className='flex_layout warnTip'>
                                    {warnIcon}
                                    <span>{t("The input cannot be empty!")}</span>
                                  </div> : null
                                }
                              </> :
                                <FreeTagInputTraceless
                                  id={"ProductFileFixTag"}
                                  tagActive={tagActive}
                                  defaultTag={TracelessTagsData('ProductFileFixTag', proFileTag)}
                                  actionList={productFileList}
                                  isShowSelectPop={ProductFileFixTagPop}
                                  changeSelectPop={this.changeSelectPop}
                                  tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'proFileTag')}
                                />
                            }
                            <div className='flex_layout imgSet_item_first'>
                              <Text variant="headingMd" as="h2" fontWeight='medium'>{t("Apply in")}</Text>
                              <ChoiceList
                                id="productFile-One"
                                title=""
                                choices={[
                                  { label: t("All product image filename"), value: '1' },
                                ]}
                                selected={`${productFile}`}
                                onChange={() => this.changeCheckState("1", "productFile-One")}
                              />
                              <ChoiceList
                                id="productFile-Two"
                                title=""
                                choices={[
                                  { label: t("Only published product image filename"), value: '2' },
                                ]}
                                selected={`${productFile}`}
                                onChange={() => this.changeCheckState("2", "productFile-Two")}
                              />
                            </div>
                          </Collapsible>
                        </div>
                      </BlockStack>
                      <div className=''>
                        <Checkbox
                          label={t("Collection image filename")}
                          id="ColFile"
                          checked={ColFile}
                          onChange={this.changeCheckState}
                        />
                        <div className={`${ColFile ? 'imgSet_tag' : 'imgSet_tag_out'}`}>
                          <Collapsible
                            open={ColFile}
                            id={`ColFile-collapsible`}
                            transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                            expandOnPrint
                          >
                            {
                              Boolean(isLocalStorage) ? <>
                                <FreeTagInputMix
                                  isBlur={isBlur}
                                  id={"ColFileFixTag"}
                                  tagActive={tagActive}
                                  defaultTag={colFileTag}
                                  actionList={colFileTagList}
                                  isShowSelectPop={ColFileFixTagPop}
                                  changeSelectPop={this.changeSelectPop}
                                  tagInputData={(e) => this.tagInputData(e, 'colFileTag')}
                                  addTags={addTagsColFile}
                                />
                                {
                                  (tagActive.length > 0 && tagActive.includes("ColFileFixTag")) ? <div className='flex_layout warnTip'>
                                    {warnIcon}
                                    <span>{t("The input cannot be empty!")}</span>
                                  </div> : null
                                }
                              </> :
                                <FreeTagInputTraceless
                                  id={"ColFileFixTag"}
                                  tagActive={tagActive}
                                  defaultTag={TracelessTagsData('ColFileFixTag', colFileTag)}
                                  actionList={colFileTagList}
                                  isShowSelectPop={ColFileFixTagPop}
                                  changeSelectPop={this.changeSelectPop}
                                  tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'colFileTag')}
                                />
                            }
                          </Collapsible>
                        </div>
                      </div>
                      <div className=''>
                        <Checkbox
                          label={t("Blog post image filename")}
                          id="BlogFile"
                          checked={BlogFile}
                          onChange={this.changeCheckState}
                        />
                        <div className={`${BlogFile ? 'imgSet_tag' : 'imgSet_tag_out'}`}>
                          <Collapsible
                            open={BlogFile}
                            id={`BlogFile-collapsible`}
                            transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                            expandOnPrint
                          >
                            {
                              Boolean(isLocalStorage) ? <>
                                <FreeTagInputMix
                                  isBlur={isBlur}
                                  id={"BlogFileFixTag"}
                                  tagActive={tagActive}
                                  defaultTag={blogFileTag}
                                  actionList={blogFileTagList}
                                  isShowSelectPop={BlogFileFixTagPop}
                                  changeSelectPop={this.changeSelectPop}
                                  tagInputData={(e) => this.tagInputData(e, 'blogFileTag')}
                                  addTags={addTagsBlogFile}
                                />
                                {
                                  (tagActive.length > 0 && tagActive.includes("BlogFileFixTag")) ? <div className='flex_layout warnTip'>
                                    {warnIcon}
                                    <span>{t("The input cannot be empty!")}</span>
                                  </div> : null
                                }
                              </> :
                                <FreeTagInputTraceless
                                  id={"BlogFileFixTag"}
                                  tagActive={tagActive}
                                  defaultTag={TracelessTagsData('BlogFileFixTag', blogFileTag)}
                                  actionList={blogFileTagList}
                                  isShowSelectPop={BlogFileFixTagPop}
                                  changeSelectPop={this.changeSelectPop}
                                  tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'blogFileTag')}
                                />
                            }
                          </Collapsible>
                        </div>
                      </div>
                    </BlockStack>
                  </div>
                </Collapsible>
              </div>
            </Card>
          }
          {/* <Card>
            <BlockStack gap={200}>
              <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
                <div className='flex_layout'>
                  <Text variant="headingMd" as="h2">{t("Auto add image alt text（Free）")}</Text>
                </div>
              </div>
              <p className='Every_Card_Desc'>{t("SEOWILL automatically generates image alt text based on predefined rules.")}</p>
              <div><Button icon={OutgoingMajor} onClick={this.jumpAltPage}>{t("Go to optimize")}</Button></div>
            </BlockStack>
          </Card> */}
        </BlockStack>
      }
    </div>

    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    return (
      <div id="ImageSettings">
        <Page
          backAction={{ content: t("Optimization Setting"), onAction: this.goBackImageOpt }}
          title={t("Optimization Setting")}
        >

          <title>SEOWILL - Image Optimization Settings</title>

          {/* 保存顶部bar */}
          <SaveBarTop
            isShowSaveBar={!setSaveDisabled}
            saveLoading={setSaveLoading}
            handleSaveAction={this.saveSetData}
            handleDiscardAction={this.handleDiscardAction}
          />

          {settingMain}
          {SaveTipModal}
          {FileExistModal}
          {FooterHelpBox}
        </Page>
      </div>
    );

  }
}


const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => ({
  // 缓存自动开关状态
  setImageAutoSwitch(data) {
    dispatch(setImageAutoSwitchData(data));
  },
})
ImageSettings = connect(
  mapStateToProps,
  mapDispatchToProps
)(ImageSettings);

export default withRouter(ImageSettings);